import { render } from "./site_page.vue?vue&type=template&id=6b8e3e50&scoped=true"
import script from "./site_page.vue?vue&type=script&lang=js"
export * from "./site_page.vue?vue&type=script&lang=js"

import "./site_page.vue?vue&type=style&index=0&id=6b8e3e50&scoped=true&lang=css"

import exportComponent from "/Users/danramage/Documents/workspace/WaterQuality/WaterQualityFrontEnd_Vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8e3e50"]])

export default __exports__